import React, { useState, useEffect } from 'react';
import RequestADemoDialog from './RequestADemoDialog';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Loader } from '@progress/kendo-react-indicators';

import { PostData } from "../../service/postData";
import { sendNotification } from "../../_notificationSettings/notificationPanel";

const HomePagePanel = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [visibleMailSendDialog, setVisibleMailSendDialog] = useState(false);
    const [mailSendTitle, setMailSendTitle] = useState('');
    const [mailSendMessage, setMailSendMessage] = useState('');
    const [openRequestADemoDialog, setOpenRequestADemoDialog] = useState(false);
    const [openDownloadDialog, setOpenDownloadDialog] = useState(false);

    useEffect(() => {
        
    }, []);

    const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    businessname: "",
    preferredmode: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    contact: "",
    preferredmode: "",
  });

  const phoneRegex = /^\d{10}$/;
  const fakeNumbers = ["0000000000", "9999999999", "1234567890"];
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;


  const validateForm = () => {
    let isValid = true;
    const newErrors = { email: "", contact: "" };

    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    if (!phoneRegex.test(formData.contact)) {
      newErrors.contact = "Enter valid mobile number.";
      isValid = false;
    }

    if (fakeNumbers.includes(formData.contact)) {
      newErrors.contact = "This mobile number is not allowed.";
      isValid = false;
    }

    if (!formData.preferredmode) {
        newErrors.preferredmode = "Please select a preferred mode of call.";
        isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const clickToSubmitEnquiry = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    let jsonData = JSON.stringify(formData);
    jsonData = JSON.parse(jsonData);
    console.log("Valid form data:", jsonData);
    
    const requestData = JSON.stringify({
        ...jsonData,
        mode: jsonData.preferredmode,
    });
    
    setIsLoading(true);
    PostData(global.sendRequestADemoMail, requestData,'POST').then((result) => {
        if(result.success == true)
        {
            setFormData({
                name: '',
                email: '',
                contact: '',
                businessname: '',
                preferredmode: '',
                message: '',
            });
            setOpenRequestADemoDialog(false);
            setVisibleMailSendDialog(true);
            setMailSendTitle(result.title);
            setMailSendMessage(result.message);
        }
        else
        {
            sendNotification("Error Message 😓","Some error occured. Please try again.","danger");
        }
    }).finally(() => {
        setIsLoading(false);
    });

  };

    return (
      <div id="page-wrapper">
        <React.Fragment>
          <a className="demo" onClick={() => setOpenRequestADemoDialog(true)}>
            Request A Demo
          </a>
          <div className="row">
            <div className="col-lg-9">
              {/* ---Menu Start Here--- */}
              <nav className="navbar navbar-expand-lg navbar-light">
                <a className="navbar-brand" href={global.webUrl}>
                  <img
                    width="200"
                    height="50"
                    src={global.webUrl + "websiteFilesFolder/img/logo.png"}
                    alt=""
                    title=""
                  />
                </a>
                <button
                  className="navbar-toggler navbar-toggler-right"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        aria-current="page"
                        href={global.webUrl}
                      >
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        href={global.webUrl + "about-us/"}
                      >
                        About Us
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href={global.webUrl + "pricing/"}>
                        Our Pricing Plans
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href={global.webUrl + "blogs/"}>
                        Blogs & News
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        href={global.webUrl + "partner-with-us/"}
                      >
                        Partner With Us
                      </a>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        More
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="navbarDropdownMenuLink"
                      >
                        <ul style={{ width: 200 }} className="futer">
                          <li>
                            <a href={global.webUrl + "features/"}>Features</a>
                          </li>
                          <li>
                            <a href={global.webUrl + "faq/"}>FAQ</a>
                          </li>
                          <li>
                            <a href={global.webUrl + "privacy-policy/"}>
                              Privacy Policy
                            </a>
                          </li>
                          <li>
                            <a href={global.webUrl + "contact/"}>
                              Contact Support
                            </a>
                          </li>
                          <li>
                            <a href={global.webUrl + "demo-videos/"}>
                              Demo Videos
                            </a>
                          </li>
                          <li>
                            <a href={global.webUrl + "terms-condition/"}>
                              Terms & Conditions
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </nav>
              {/* ---End Menu--- */}
            </div>
            <div className="col-lg-3">
              <div className="top_right">
                <ul>
                  <li>
                    <a href={global.webUrl + "login/"}>Log In</a>
                  </li>
                  <li>
                    {/* Modal picker so iOS + Android can share one CTA.
                        Kept as an anchor to inherit the existing
                        .top_right ul li:last-child a magenta styling
                        (see layout.css:1803). href points at the APK
                        as a graceful-degradation fallback — if JS ever
                        fails, clicking still starts the Android download
                        (the intended primary action for 95% of visitors).
                        onClick preventDefault → opens the picker
                        instead in the normal happy path. */}
                    <a
                      href={global.webUrl + "apk/vyavsay.apk"}
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenDownloadDialog(true);
                      }}
                    >
                      Download
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="livechat">
              <a
                href="https://tawk.to/chat/5d240b0822d70e36c2a4caab/default"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={global.webUrl + "img/chat.png"} alt="Live Chat" />
              </a>
            </div>
            <div className="dcnpl_callnow">
              <a
                href="tel:+919755299999"
                onClick={() =>
                  window.ga?.(
                    "send",
                    "event",
                    "Call Us",
                    "Click to Call Button",
                    "Click to Call Button"
                  )
                }
              >
                <img
                  src={global.webUrl + "img/contact-calling.png"}
                  alt="contact calling"
                  title="contact calling"
                />
              </a>
            </div>
            <a href="https://api.whatsapp.com/send?phone=919755299999&text=I%20am%20interested%20in%20Digitizing%20my%20business%20through%20Vyavsay%20App%20please%20send%20the%20Details">
              <div className="chat-icon1" i-amphtml-fixedid="F3">
                <img
                  src={global.webUrl + "img/contact-whatsapp.png"}
                  alt="contact whatsapp"
                  title="contact whatsapp"
                />
              </div>
            </a>
          </div>
          {openRequestADemoDialog && (
            <Dialog>
              <RequestADemoDialog
                onSubmit={(e) => clickToSubmitEnquiry(e)}
                closeDialog={() => {
                  setOpenRequestADemoDialog(false);
                }}
                setFormData={setFormData}
                formData={formData}
                setErrors={setErrors}
                errors={errors}
              />
            </Dialog>
          )}

          {visibleMailSendDialog && (
            <Dialog
              title={mailSendTitle}
              onClose={() => setVisibleMailSendDialog(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                {mailSendMessage}
              </p>
              <DialogActionsBar>
                <button
                  type="submit"
                  className="btn btn-primary text-right"
                  onClick={() => {
                    setOpenRequestADemoDialog(false);
                    setVisibleMailSendDialog(false);
                  }}
                >
                  Ok
                </button>
              </DialogActionsBar>
            </Dialog>
          )}
          {isLoading && (
            <Dialog>
              <Loader type="converging-spinner" />
            </Dialog>
          )}

          {/* OS picker for the Download CTA. Same Kendo Dialog primitive
              the RequestADemo path uses so styles + accessibility (focus
              trap, ESC-to-close) stay consistent. Mobile responsiveness
              comes from `.download-os-picker` (see layout.css) — the
              two OS cards flex-wrap and stretch to full width below
              480 px. */}
          {openDownloadDialog && (
            <Dialog
              title="Download Vyavsay"
              onClose={() => setOpenDownloadDialog(false)}
              className="download-os-picker"
              width="min(92vw, 480px)"
            >
              <div style={{ padding: "8px 20px 24px 20px" }}>
                <p
                  style={{
                    margin: "0 0 20px 0",
                    textAlign: "center",
                    color: "#5c5c5c",
                    fontSize: "15px",
                  }}
                >
                  Choose your platform
                </p>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "16px",
                    justifyContent: "center",
                  }}
                >
                  {/* Android — live APK from the same host that serves
                      the SPA. `download` attribute is a redundant hint
                      for browsers that don't honour Content-Disposition
                      (the nginx block on 184.33.24.244 already sends
                      Content-Disposition: attachment). */}
                  <a
                    href={global.webUrl + "apk/vyavsay.apk"}
                    download="vyavsay.apk"
                    onClick={() => setOpenDownloadDialog(false)}
                    className="download-os-card"
                    style={{
                      flex: "1 1 180px",
                      minWidth: 0,
                      padding: "24px 16px",
                      borderRadius: "12px",
                      border: "2px solid #b63266",
                      background: "#fff",
                      color: "#b63266",
                      textAlign: "center",
                      textDecoration: "none",
                      fontFamily: "'Montserrat', sans-serif",
                      fontWeight: 600,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "10px",
                      transition: "background .2s, color .2s",
                    }}
                  >
                    <span style={{ fontSize: "40px", lineHeight: 1 }} aria-hidden="true">🤖</span>
                    <span style={{ fontSize: "16px" }}>Android</span>
                    <span style={{ fontSize: "12px", color: "#8a8a8a", fontWeight: 400 }}>
                      .apk direct download
                    </span>
                  </a>

                  {/* iOS — placeholder until the App Store listing goes
                      live. Rendered as a non-interactive card with a
                      "Coming soon" tag so the two options line up
                      visually without misleading anyone into thinking
                      the tap will do something. Swap for an
                      `<a href="https://apps.apple.com/...">` once the
                      listing is up. */}
                  <div
                    className="download-os-card download-os-card--disabled"
                    aria-disabled="true"
                    style={{
                      flex: "1 1 180px",
                      minWidth: 0,
                      padding: "24px 16px",
                      borderRadius: "12px",
                      border: "2px dashed #cfcfcf",
                      background: "#fafafa",
                      color: "#8a8a8a",
                      textAlign: "center",
                      fontFamily: "'Montserrat', sans-serif",
                      fontWeight: 600,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "not-allowed",
                      position: "relative",
                    }}
                  >
                    <span style={{ fontSize: "40px", lineHeight: 1 }} aria-hidden="true">🍎</span>
                    <span style={{ fontSize: "16px" }}>iOS</span>
                    <span
                      style={{
                        fontSize: "11px",
                        background: "#e9e9e9",
                        color: "#5c5c5c",
                        padding: "3px 10px",
                        borderRadius: "999px",
                        fontWeight: 500,
                        letterSpacing: ".3px",
                      }}
                    >
                      Coming soon
                    </span>
                  </div>
                </div>
              </div>
            </Dialog>
          )}
        </React.Fragment>
      </div>
    );
};

export default HomePagePanel;